const currentUrl = window.location.href;
//check if running in development, ipt or production
const getDeployEnvironment = () => {
  if (currentUrl.includes("localhost")) {
    return "dev";
  } else if (currentUrl.includes("ipt")) {
    return "ipt";
  } else if (currentUrl.includes("ra")) {
    return "pre-prod";
  } else {
    return "prod";
  }
};

export const DEPLOY_ENVIRONMENT = getDeployEnvironment();
export const APP_VERSION = "2.0.0";
